import { connect } from 'react-redux';
import withLocalLoader from 'components/HOCs/withLocalLoader';
import ReconciliationFormsView from './ReconciliationFormsView';
import { getReconciliationForms } from 'state/actions/actions';

function mapStateToProps({ reconciliationForms }) {
  return {
    records: reconciliationForms.records,
    contacts: reconciliationForms.contacts
  };
}

export default connect(mapStateToProps, { getReconciliationForms })(
  withLocalLoader(
    ReconciliationFormsView,
    true,
    'Reconciliation Forms',
    'Reconciliation Forms'
  )
);
